import { PaymentMethod } from "../../payment";
import { getCardVerificationSupported } from "./paymentGateways/behaviors";

export const cardVerification = {
    isSupported: (paymentMethod: PaymentMethod) => !!getCardVerificationSupported(paymentMethod),
};
